import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=63864d29"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63864d29')) {
      api.createRecord('63864d29', component.options)
    } else {
      api.reload('63864d29', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=63864d29", function () {
      api.rerender('63864d29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/example/edit.vue"
export default component.exports